import { useAuth } from '../context/AuthContext';

const PRO_FEATURES = [
  'pdf_export',
  'broker_comparison',
  'monte_carlo',
  'unlimited_accounts',
  'unlimited_retention',
];

export function useSubscription() {
  const { user } = useAuth();

  const plan = user?.plan || 'free';
  const effectivePlan = user?.effectivePlan || plan;
  const isTrialActive = user?.isTrialActive || false;
  const trialDaysRemaining = user?.trialDaysRemaining || 0;

  const isPro = effectivePlan === 'pro';
  const isTrial = effectivePlan === 'trial';
  const isFree = effectivePlan === 'free';
  const hasProAccess = isPro || isTrial;  // PRO or trial users have full access

  const canAccess = (feature) => {
    if (hasProAccess) return true;
    return !PRO_FEATURES.includes(feature);
  };

  const requireUpgrade = (feature) => {
    return isFree && PRO_FEATURES.includes(feature);
  };

  return {
    plan,
    effectivePlan,
    isPro,
    isTrial,
    isFree,
    hasProAccess,
    isTrialActive,
    trialDaysRemaining,
    canAccess,
    requireUpgrade,
  };
}
